module.exports = __webpack_public_path__ + "static/img/swiper-guide-txt.9277d20.png";